// 判断是否为服务器环境
export const isServer = typeof window === 'undefined';
// 判断运行环境
export const env = isServer ? process.env.APP_ENV : process.env.NEXT_PUBLIC_APP_ENV;
// 判断是否本地联调
export const isLocal = env === 'local';
// 判断是否生产环境
export const isPro = env === 'pro';

let url = 'https://devwww.szlcsc.com';
if (env === 'dev') {
  url = 'https://dev-www.szlcsc.com';
} else if (env === 'fat') {
  url = 'https://fatwww.szlcsc.com';
} else if (env === 'uat') {
  url = 'https://uatwww.szlcsc.com';
} else if (env === 'pro') {
  url = 'https://www.szlcsc.com';
}

export const baseURL = url;
